<div id="doctors-list" class="flex flex-col gap-3">
  <div class="flex flex-row justify-between">
    <a class="cursor-pointer flex flex-row" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      <p>Back</p>
    </a>
  </div>
  <div class="card flex p-5 flex-col justify-between">
    <div id="doctors-list-header" class="flex flex-row justify-between kit">
      <p>Barcode</p>
      <p>Registered at</p>
      <p>Registered by</p>
    </div>
    <mat-divider></mat-divider>
    <div class="body flex flex-col gap-3 mt-3">
      @if (!!kits) {
        @for (kit of kits; track kit['kit_id']) {
          <div class="custom-btn rounded-lg" (click)="openKits(kit)">
            <div class="flex flex-row justify-between p-3 cursor-pointer kit">
              <p>{{ kit.barcode }}</p>
              <p>{{ kit.registered_at | date }}</p>
              <p>{{ kit.registered_by }}</p>
            </div>
          </div>
        }
      } @else {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>
  </div>
</div>
